import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { Subscription } from "rxjs";
import { ButtonSheetService } from "src/app/services/button-sheet.service";

@Component({
  selector: "app-leitor-side-tools-mobile",
  templateUrl: "./leitor-side-tools-mobile.component.html",
  styleUrls: ["./leitor-side-tools-mobile.component.scss"],
})
export class LeitorSideToolsMobileComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  constructor(
    private _bottomSheet: MatBottomSheet,
    private buttonSheetService: ButtonSheetService
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
  }

  toggleOpenBottomSheet(open: boolean): void {
    if (open) {
      this._bottomSheet.open(LeitorSideToolsMobileSheetComponent, {
        panelClass: "custom-background-leitor-side-tools",
      });
    }
  }
}

@Component({
  selector: "app-leitor-side-tools-mobile-sheet",
  templateUrl: "./leitor-side-tools-mobile-sheet.component.html",
  styleUrls: ["./leitor-side-tools-mobile.component.scss"],
})
export class LeitorSideToolsMobileSheetComponent implements OnInit, OnDestroy {
  private subscriptions: Subscription[] = [];

  constructor(
    private _bottomSheet: MatBottomSheet,
    private buttonSheetService: ButtonSheetService
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
  }
}
